module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý vùng miền"
    }
  }, [_c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'create-region'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm\n      mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.regionTable,
    attrs: {
      "table-name": _vm.regionTable,
      "data-source": "regions",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": "",
            "row-class-name": _vm.tableRowClassName
          }
        }, [_vm._v("\n          >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.regionTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.regionTable].current_page - 1) * _vm.dataPaginations[_vm.regionTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tên"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.name))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tên Viết Tắt"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.short_name))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [(!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Chi tiết"
                }
              }, [_c('a', {
                staticClass: "text-blue padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.detailRegion(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-search"
              })])]) : _vm._e(), _vm._v(" "), (!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('router-link', {
                staticClass: "text-orange padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'edit-region',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o",
                attrs: {
                  "aria-hidden": "true"
                }
              })])], 1) : _vm._e(), _vm._v(" "), (!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deleteRegion(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Khôi phục"
                }
              }, [_c('a', {
                staticClass: "text-blue padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.restore(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-refresh",
                attrs: {
                  "aria-hidden": "true"
                }
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Chi tiết vùng miền: ' + _vm.region.name,
      "visible": _vm.detailModal
    },
    on: {
      "update:visible": function($event) {
        _vm.detailModal = $event
      }
    }
  }, [(_vm.region.cities) ? _c('el-table', {
    attrs: {
      "data": _vm.region.cities.data
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "name",
      "label": "Tên"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0d485e5d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/region/Region.vue
// module id = 694
// module chunks = 1